import { type InferInsertModel, type InferSelectModel, relations } from 'drizzle-orm';
import {
  boolean,
  doublePrecision,
  pgTable,
  text,
  timestamp,
  uuid,
} from 'drizzle-orm/pg-core';
import { shirtTypeCollarTypes, shirtTypeSleeveTypes } from './compatibility';

export const shirtTypes = pgTable('shirt_types', {
  id: uuid('id')
    .primaryKey()
    .$defaultFn(() => Bun.randomUUIDv7()),
  description: text('description').notNull(),
  price: doublePrecision('price').notNull(),
  isActive: boolean('is_active').default(true),
  createdAt: timestamp('created_at')
    .notNull()
    .$defaultFn(() => new Date()),
  updatedAt: timestamp('updated_at')
    .$onUpdate(() => new Date())
    .notNull(),
});

export const shirtTypesRelations = relations(shirtTypes, ({ many }) => ({
  shirtTypeSleeveTypes: many(shirtTypeSleeveTypes),
  shirtTypeCollarTypes: many(shirtTypeCollarTypes),
}));

export type ShirtType = InferSelectModel<typeof shirtTypes>;
export type CreateShirtTypeInput = InferInsertModel<typeof shirtTypes>;
export type UpdateShirtTypeInput = Partial<CreateShirtTypeInput>;
